var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-component-headline-text"},[_c('h4',{staticClass:"component-headline"},[_vm._v("\n        "+_vm._s(_vm.content.headline)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"component-text",domProps:{"innerHTML":_vm._s(_vm.content.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-149993f6","hasScoped":false,"buble":{"transforms":{}}}!./src/pagebuilder-components/HeadlineText/HeadlineText.html
// module id = null
// module chunks = 